const TextAlignment = {
     attrs: {
       style: { default: null },
       class: { default: 'alignment' },
     },
     inclusive: false,
     parseDOM: [
       {
         tag: 'p.alignment',
         getAttrs(hook, next) {
           Object.assign(hook, {
             class: hook.dom.getAttribute('class'),
             style: hook.dom.getAttribute('style'),
           });
           next();
         },
       },
     ],
     toDOM(hook, next) {
       // eslint-disable-next-line no-param-reassign
       hook.value = ['p', hook.node.attrs, 0];
       next();
     },
   };
   
   export default TextAlignment;